import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#FFFDE7]/80 via-[#FCE4EC] to-[#EDE7F6]/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12">
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-[#F48FB1] mb-4 sm:mb-6">
              おかやま小児科クリニック
            </h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              岡山市のお子様の健康を<br />
              笑顔でサポートします
            </p>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-4 sm:mb-6">
              アクセス
            </h4>
            <div className="space-y-2 text-sm sm:text-base text-gray-600">
              <p>〒700-0000</p>
              <p>岡山市北区○○町1-2-3</p>
              <p className="pt-2">
                <span className="font-medium">TEL:</span> 086-012-3456
              </p>
              <p>
                <span className="font-medium">FAX:</span> 086-012-3457
              </p>
            </div>
            <h4 className="text-base sm:text-lg font-bold text-gray-800 mt-6 mb-4 sm:mb-6">
              診療時間
            </h4>
            <div className="space-y-2 text-sm sm:text-base text-gray-600">
              <p>月〜土：9:00 - 18:00</p>
              <p className="text-red-500 font-medium">
                定休日：日曜日・祝日
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-4 sm:mb-6">
              メニュー
            </h4>
            <nav className="space-y-2 text-sm sm:text-base">
              <Link
                to="/"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                HOME
              </Link>
              <Link
                to="/about"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                当院について
              </Link>
              <Link
                to="/services"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                診療案内
              </Link>
              <Link
                to="/facilities"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                施設紹介
              </Link>
              <Link
                to="/recruit"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                採用情報
              </Link>
              <Link
                to="/contact"
                className="block text-gray-600 hover:text-[#F48FB1] transition-colors whitespace-nowrap"
              >
                お問い合わせ
              </Link>
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex justify-center items-center">
            <p className="text-xs sm:text-sm text-gray-500 text-center">
              © 2000-2025 おかやま小児科クリニック All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
